import Vue from 'vue'
import Vuex from 'vuex'
import authStore from 'chilogin/lib/store'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth: { ...authStore }
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js